(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.playcationDestinationsView = {
    attach: function (context, settings) {

      once('playcation-filter', '.play-filter', context).forEach(function (playFilter) {

        // ── Elements ────────────────────────────────────────────
        const playcationContainer = document.querySelector(
          '.landing-page--playcation .view-content.hide-extra'
        );
        const viewsItems = document.querySelectorAll(
          '.landing-page--playcation .view-content.hide-extra .views-row'
        );
        const trigger = playFilter.querySelector('.play-filter--closed');
        const listbox = document.getElementById('play-filter-listbox');
        const status = document.getElementById('play-filter-status');
        const options = listbox
          ? Array.from(listbox.querySelectorAll('[role="option"]'))
          : [];

        if (!trigger || !listbox || !playcationContainer) {return;}

        // ── Initialization ───────────────────────────────────────
        // No $(document).ready() — attach() already runs at the right time ✅
        Drupal.behaviors.playcationDestinationsView.applyFilters('all');

        const initialItems = playcationContainer.querySelectorAll(
          '.views-row:not([hidden])'
        );
        Drupal.behaviors.playcationDestinationsView.playcationHideShow(initialItems);

        // ── Open/Close with focus control ────────────────────────
        function openDropdown() {
          trigger.setAttribute('aria-expanded', 'true');
          listbox.removeAttribute('hidden');
          playFilter.classList.add('open');

          const selected = listbox.querySelector('[aria-selected="true"]') || options[0];
          if (selected) {
            selected.focus();
          }
        }

        function closeDropdown(returnFocus) {
          trigger.setAttribute('aria-expanded', 'false');
          listbox.setAttribute('hidden', '');
          playFilter.classList.remove('open');

          if (returnFocus) {
            trigger.focus(); // ← returns focus to trigger ✅
          }
        }

        // ── Announce results ─────────────────────────────────────
        function announceResults() {
          if (!status) {return;}

          const visibleItems = playcationContainer.querySelectorAll(
            '.views-row:not([hidden])'
          );
          status.textContent = Drupal.formatPlural(
            visibleItems.length,
            '1 result found',
            '@count results found'
          );
        }

        // ── Trigger events ───────────────────────────────────────
        trigger.addEventListener('click', function () {
          if (trigger.getAttribute('aria-expanded') === 'true') {
            closeDropdown(true);
          }
          else {
            openDropdown();
          }
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openDropdown();
          }
        });

        // ── Keyboard navigation in listbox ───────────────────────
        listbox.addEventListener('keydown', function (e) {
          const currentIndex = options.indexOf(document.activeElement);

          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              if (currentIndex < options.length - 1) {
                options[currentIndex + 1].focus();
              }
              break;

            case 'ArrowUp':
              e.preventDefault();
              if (currentIndex > 0) {
                options[currentIndex - 1].focus();
              }
              // When on first option, keep focus here
              break;

            case 'Home':
              e.preventDefault();
              options[0].focus();
              break;

            case 'End':
              e.preventDefault();
              options[options.length - 1].focus();
              break;

            case 'Escape':
              e.preventDefault();
              closeDropdown(true); // ← returns focus to trigger ✅
              break;

            case 'Tab':
              closeDropdown(false); // ← does not return focus ✅
              break;
          }
        });

        // ── Select option ────────────────────────────────────────
        options.forEach(function (option) {
          option.addEventListener('click', function () {
            selectOption(option);
          });

          option.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              selectOption(option);
            }
          });
        });

        // ── Close on outside click ───────────────────────────────
        document.addEventListener('mouseup', function (e) {
          if (!playFilter.contains(e.target)) {
            if (trigger.getAttribute('aria-expanded') === 'true') {
              closeDropdown(false); // ← does not return focus ✅
            }
          }
        });

        // ── Post-AJAX focus ──────────────────────────────────────
        $(document)
          .off('ajaxComplete.playcation')
          .on('ajaxComplete.playcation', function () {
            announceResults();
          });

        // ── Load More / Show Less ────────────────────────────────
        once('playcation-load-more',
          '.landing-page--playcation .view-button .button',
          context
        ).forEach(function (btn) {
          btn.addEventListener('click', function () {
            const items = playcationContainer.querySelectorAll(
              '.views-row:not([hidden])'
            );
            const viewContent = playcationContainer;

            btn.textContent = btn.textContent.trim() === 'Load More'
              ? 'Show Less'
              : 'Load More';

            if (viewContent.classList.contains('hide-extra')) {
              viewContent.classList.remove('hide-extra');
              viewsItems.forEach(function (div) {
                div.removeAttribute('style');
              });
            }
            else {
              viewContent.classList.add('hide-extra');
              Drupal.behaviors.playcationDestinationsView.playcationHideShow(items);
            }
          });
        });

        // ── Helper: Select option ────────────────────────────────
        function selectOption(option) {
          const filterValue = option.getAttribute('data-value');

          options.forEach(function (opt) {
            opt.setAttribute('aria-selected', 'false');
            opt.classList.remove('selected');
          });

          option.setAttribute('aria-selected', 'true');
          option.classList.add('selected');

          trigger.textContent = option.textContent.trim(); // ← no span needed ✅

          // Dispatch custom event for analytics tracking ✅
          option.dispatchEvent(new CustomEvent('playcation:filter-selected', {
            bubbles: true,
            detail: {label: option.textContent.trim()}
          }));

          Drupal.behaviors.playcationDestinationsView.applyFilters(filterValue);
          closeDropdown(true); // ← returns focus to trigger after selection ✅
          announceResults();

          const items = playcationContainer.querySelectorAll(
            '.views-row:not([hidden])'
          );
          const loadMoreBtn = document.querySelector(
            '.landing-page--playcation .view-button .button'
          );

          if (loadMoreBtn && loadMoreBtn.textContent.trim() === 'Show Less') {
            loadMoreBtn.textContent = 'Load More';
          }

          viewsItems.forEach(function (div) {
            div.removeAttribute('style');
          });

          if (items.length <= 6) {
            $('.landing-page--playcation .view-button').hide();
          }
          else {
            $('.landing-page--playcation .view-button').show();
            for (let i = 6; i < items.length; i++) {
              items[i].style.display = 'none';
            }
          }
        }

      }); // end once

    }, // end attach

    playcationHideShow: function (playcationItems) {
      if (playcationItems.length >= 6) {
        for (let i = 6; i < playcationItems.length; i++) {
          playcationItems[i].style.display = 'none';
        }
        $('.landing-page--playcation .view-button').show();
      }
      else {
        $('.landing-page--playcation .view-button').hide();
      }
    },

    applyFilters: function (filterValue) {
      $('.view-display-id-block_1.view-playcation-destinations .views-row')
        .removeAttr('hidden');

      if (filterValue !== 'all') {
        $(
          '.node--playcation-destination-page-teaser[data-location!=' + filterValue + ']'
        ).closest('.views-row').attr('hidden', '');

        $(
          '.node--playcation-destination-page-teaser[data-location=statewide]'
        ).closest('.views-row').removeAttr('hidden');
      }
    }

  };

})(jQuery, Drupal, once);
